import { Component, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { Stockitem } from '../../../../interfaces/stockitem';
import { MatSelect } from '@angular/material/select';
import { SelectedProductDetail } from '../../../../interfaces/addorder';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { OrdersService } from '../../../../services/orders';
import { ProfileService } from '../../../../services/profile.service';
import { CartService } from '../../../../services/cart';
import { LoginService } from '../../../Authentication/auth/login.service';
import { AddaddressComponent } from '../../profile/addresses/addaddress/addaddress.component';
import { ResigteringService } from '../../../Authentication/auth/resigtering.service';
import { UserAddresses } from '../../../../services/userAddresses';
import { PromocodeService } from '../../../../services/promo-code';
import { WalletService } from '../../../../services/wallet';
import { SpinService } from '../../../../services/spinservice';

@Component({
  selector: 'app-addorderclient',
  templateUrl: './addorderclient.component.html',
  styleUrls: ['./addorderclient.component.scss'],
  encapsulation: ViewEncapsulation.None, // This will disable encapsulation

})
export class AddorderclientComponent {

  @ViewChild('productSelect', { static: false }) productSelect!: ElementRef;
  createdOrderId: number | null = null;
  createdOrderTotal: number = 0;
  gustUserId: any = null;
  client_name!: string;
  phone_number!: string;
  another_phone!: string;
  contentReady: boolean = false;
  address!: any;

  hasFreeDeliveryReward = false;


  delivery_fees: any = 0;


  note!: string;



  userId!: string;


  arrayofitems: any = [];
  arrayofOlditems: any = [];
  arrayofqty: any = [];
  arrayofprices: any = [];
  arrayofids: any = [];
  data!: FormGroup;


  selectedBundlesDetails: any[] = [];



  isMobile: boolean = false;


  productname: Stockitem[] = [];
  productnamefixed: Stockitem[] = [];
  isAr: boolean = false;
  productindex: number = 0;
  productqtyindex: number = 0;
  productpriceindex: number = 0;
  selectedValueFromStock: any = true;

  thisUserId: any;
  selectedProduct: any = null;
  due!: any;
  income!: any;
  total!: any;
  totalOriginalPrice: number = 0;
  totalUserEnteredPrice: number = 0;
  originalPrice: number = 0;
  selectedProductsDetails: SelectedProductDetail[] = [];
  providers = new FormControl();
  allProviders: any[] = this.productname;
  users!: any;
  createOrderByid!: any;
  createOrderByidType!: any;
  filteredProviders: any[] = this.productname;
  cartItems: any[] = this.productname;
  orderLocation!: any;
  clearClientBtn: boolean = false;
  clearcart: boolean = false;
  isUpdate: boolean = false;
  warehouseId!: any;
  orderId!: any;
  isExpired: boolean = false;
  parmsPrices!: any;
  carttotal!: any;
  discount!: any;
  dataForm: any;
  cityId!: any;
  grovId!: any;
  @ViewChild('addressFormRef') addressFormComponent!: AddaddressComponent;
  @ViewChild('mySelect') mySelect!: MatSelect;
  tokenExists!: boolean;
  promoCodeType!: any;
  promocode!: any;
  yourSave!: any;
  balance: any = 0;
  debit: any = 0;
  paymentType: number = 0;
  walletApplied: boolean = false;
  constructor(
    private router: Router,
    private _profileService: ProfileService,
    private fb: FormBuilder,
    private _orderService: OrdersService,
    private _ResigteringService: ResigteringService,
    private deviceService: DeviceDetectorService,
    private _userService: UserService,
    private addressesService: UserAddresses,
    private _cart: CartService,
    private walletService: WalletService,
    private _LoginService: LoginService,
    private promoService: PromocodeService,
    private spinService: SpinService,

  ) {

  }
  token = localStorage.getItem('token');
  checkForToken() {
    this._LoginService.token$.subscribe((token) => {
      this.tokenExists = token != null;
    });
  }
  ngAfterViewInit() {
  }

  async selectPayment(type: number) {
    // لو مش أونلاين بايمنت اختار عادي
    if (type !== 3) {
      this.paymentType = type;
      return;
    }

    const result = await Swal.fire({
      icon: 'warning',
      title: this.isAr ? 'رسوم الدفع الأونلاين' : 'Online payment fees',
      html: this.isAr
        ? `
        <div style="line-height:1.9;text-align:right">
          عند اختيار <b>الدفع الأونلاين</b> يتم إضافة <b>3%</b> على إجمالي الطلب
          وهي رسوم خاصة بالبنك .

          لو لا تريد دفع هذه الرسوم يمكنك اختيار:

          <b>كاش</b> أو <b>إنستاباي</b> أو <b>محفظة مع مندوب الشحن</b>.
        </div>
      `
        : `
        <div style="font-size:14px!important;line-height:1.9;text-align:left">
          Choosing <b>online payment</b> adds <b>3%</b> to the total order.
          This fee is charged by the bank.

          If you do not want to pay this fee, you can choose:

          <b>Cash</b>, <b>InstaPay</b>, or <b>Wallet with the delivery courier</b>.
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'موافق، أكمل أونلاين' : 'Continue with online payment',
      cancelButtonText: this.isAr ? 'لا، سأختار طريقة أخرى' : 'No, I will choose another method',
      reverseButtons: true
    });

    if (result.isConfirmed) {
      this.paymentType = 3;
    } else {
      this.paymentType = 0;
    }
  }
  onOnlinePaymentSuccess(event: any) {
    // 🔥 الدفع تم
    console.log('Payment Success:', event);

    Swal.fire({
      icon: 'success',
      title: this.isAr ? 'تم الدفع بنجاح' : 'Payment Successful',
      timer: 1500,
      showConfirmButton: false
    });

    this._cart.clearCart();
    this.router.navigateByUrl('/ordercompleted');
  }

  onOnlinePaymentFailed(error: any) {
    Swal.fire({
      icon: 'error',
      title: this.isAr ? 'فشل الدفع' : 'Payment Failed',
      text: this.isAr ? 'حاول مرة أخرى' : 'Please try again'

    });
  }
  ngOnInit() {
    this.checkForToken();

    if (localStorage.getItem('shipping') != null)
      this.onAddressChange(localStorage.getItem('shipping'))

    if (Number.isNaN(this.delivery_fees))
      this.delivery_fees = 0

    this.isMobile = this.deviceService.isMobileDevice();

    this.isAr = localStorage.getItem("language") == "ar";

    this.warehouseId = localStorage.getItem("posId");

    if (this.token)
      this.getUserDataForOrder()


    let storedCart = localStorage.getItem("cart");
    if (storedCart) {
      this.yourSave = localStorage.getItem("cartDiscount");
      const total = localStorage.getItem("cartTotal");
      this.carttotal = total ? parseInt(total, 10) : 0;

      this.clearcart = true;
      const cartItems = JSON.parse(storedCart);
      this.selectedValueFromStock = false;
      this.onProductSelected(cartItems);
    }
    else {
      this.router.navigateByUrl('/cart');
    }
    this.hasFreeDeliveryReward = localStorage.getItem('free_delivery_reward') === '1';

    if (this.hasFreeDeliveryReward) {
      this.promoCodeType = "free delivery";   // عشان onAddressChange مايرجعش يغيّرها
      this.delivery_fees = 0;

      // لو عندك carttotal/total بيتحسب بدليفري، سيبها هنا 0
    }

    this.initiate();
  }
  applyWallet() {
    if (this.walletApplied)
      return

    if (this.carttotal < this.balance) {

      this.discount = this.carttotal;
      this.debit = this.discount;
      this.balance = this.balance - this.carttotal;
      this.carttotal = 0;
      this.walletApplied = true;

      Swal.fire({
        icon: 'success',
        title: this.isAr ? "تم استخدام المحفظة بنجاح" : 'Wallet Balance applied successfully',
        confirmButtonText: this.isAr ? 'تمام' : 'ok',
      });
    }
    else {

      this.discount = this.balance;
      this.carttotal = this.carttotal - this.balance;
      this.walletApplied = true;
      this.debit = this.balance;
      this.balance = 0;
      Swal.fire({
        icon: 'success',
        title: this.isAr ? "تم استخدام المحفظة بنجاح" : 'Wallet Balance applied successfully',
        confirmButtonText: this.isAr ? 'تمام' : 'ok',
      });
    }



  }
  addPromoCode(code: string) {
    if (code == "" || code == null || code == undefined) {
      Swal.fire({
        icon: 'error',
        title: this.isAr ? "يرجى إدخال كود الخصم" : 'please enter promo code',
        confirmButtonText: this.isAr ? 'تمام' : 'ok',
      });
    }
    const promocode = (code || '').trim();
    if (!promocode) { return; }
    if (this.promocode != null) { return; }
    this.promoService.validate(promocode).subscribe(res => {
      if (res.valid) {
        this.promocode = promocode;
        res.data?.type === '0' ? this.promoCodeType = "free delivery" : this.promoCodeType = "discount"

        if (this.promoCodeType === "free delivery") {
          this.delivery_fees = 0;
          Swal.fire({
            icon: 'success',
            title: this.isAr ? "تم ادخال الكود بنجاح" : 'Promo code applied successfully',
            text: this.isAr ? "لقد حصلت على توصيل مجاني" : 'You got a free delivery',
            confirmButtonText: this.isAr ? 'تمام' : 'ok',
          });
        }
        else if (this.promoCodeType === "discount") {
          const off = this.carttotal * (res.data?.percentage || 0) / 100;
          this.discount = off;
          this.carttotal = this.carttotal - off;
          Swal.fire({
            icon: 'success',
            title: this.isAr ? "تم ادخال الكود بنجاح" : 'Promo code applied successfully',
            text: this.isAr ? "لقد حصلت على خصم" : 'You got a discount',
            confirmButtonText: this.isAr ? 'تمام' : 'ok',
          });
        }
      }
      else {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل ادخال الكود" : 'Promo code application failed',
          text: this.isAr ? "الكود غير صالح" : 'The code is invalid',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });
      }
    });
  }
  onProductSelected(event: any) {

    let selectedProducts: any[] = [];
    let selectedBundles: any[] = [];

    if (Array.isArray(event)) {

      // ✅ جاي من localStorage
      event.forEach((item: any) => {

        if (item.type === "bundle") {

          // 🟢 Bundle
          selectedBundles.push({
            bundle: item.product,
            quantity: Number(item.quantity) || 1,
            price: Number(item.product.price) || 0
          });

        } else {

          // 🟢 Normal Product
          selectedProducts.push({
            product: item.product,
            quantity: Number(item.quantity) || 1,
            price: Number(
              item.product.is_daily_offer
                ? item.product.affiliationprice
                : item.product.pricec
            ) || 0
          });
        }

      });

    }

    // ✅ خزّن المنتجات
    this.selectedProductsDetails = selectedProducts;

    // ✅ خزّن الباندلز
    this.selectedBundlesDetails = selectedBundles;

    console.log("Products:", this.selectedProductsDetails);
    console.log("Bundles:", this.selectedBundlesDetails);
  }

  onAddressChange(address: any) {
    if (this.promoCodeType == "free delivery" || this.hasFreeDeliveryReward)
      return
    this.delivery_fees = parseInt(address);
  }
  clearProduct() {
    localStorage.removeItem("cart");
    this.clearcart = false;

  }
  getUserDataForOrder() {
    this.contentReady = true;
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.userId = data['user_id'];
        this._profileService.getuserinfo(this.userId).subscribe({
          next: (res) => {
            console.log(res)
            this.contentReady = false
            this.client_name = res.first_name;
            this.phone_number = res.phone;
            this.another_phone = res.phone;
            if (res.type == "9")
              this.loadUserBalance(this.userId)
          },
          error: (err) => this.contentReady = false
        });
      },
      error: (error) => console.error(error),
    });
  }
  loadUserBalance(id: any): void {
    this.walletService.getUserWallet(parseInt(id)).subscribe({
      next: (res) => {
        this.balance = res.balance;

        this.contentReady = false;
      },
      error: (err) => console.error(err)
    });
  }
  openSelect() {
    this.mySelect.open();
  }
  initiate() {
    if (this.tokenExists) {

      this.data = this.fb.group({
        client_name: [''],
        phone_number: [''],
        another_phone: [''],
        address: [''],
        quantity: [''],
        item: [''],
        createby: [''],
        price: [''],
        delivery_fees: [''],
        note: [''],
        arrayofids: ['']
      });

    }
    else {

      this.data = this.fb.group({
        client_name: ['', Validators.required],
        phone_number: ['', [
          Validators.required,
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.pattern(/^01[0-9]{9}$/)
        ]],
        another_phone: [''],
        address: [''],
        quantity: [''],
        item: [''],
        createby: [''],
        price: [''],
        delivery_fees: [''],
        note: [''],
        arrayofids: ['']
      });

    }
  }
  submitSelectedProducts() {
    this.arrayofitems = [];
    this.arrayofids = [];
    this.arrayofprices = [];
    this.arrayofqty = [];
    this.arrayofOlditems = [];

    this.totalUserEnteredPrice = 0;
    this.total = 0;

    for (const item of this.selectedProductsDetails) {
      const product = item.product;
      const qty = Number(item.quantity) || 1;

      // السعر الأصلي الحقيقي للقطعة
      const originalPrice = Number(
        item.product?.is_daily_offer
          ? item.product?.affiliationprice
          : item.product?.pricec
      ) || 0;

      // لو المنتج جاي من عجلة الحظ
      if (product?.is_free_reward) {
        // أول قطعة مجانية
        this.arrayofitems.push(product.name_ar);
        this.arrayofids.push(product.id);
        this.arrayofprices.push(0);
        this.arrayofqty.push(1);
        this.arrayofOlditems.push(originalPrice);

        // الباقي بسعره الطبيعي
        if (qty > 1) {
          this.arrayofitems.push(product.name_ar);
          this.arrayofids.push(product.id);
          this.arrayofprices.push(originalPrice);
          this.arrayofqty.push(qty - 1);
          this.arrayofOlditems.push(originalPrice);

          this.total += originalPrice * (qty - 1);
        }
      } else {
        // منتج عادي
        this.arrayofitems.push(product.name_ar);
        this.arrayofids.push(product.id);
        this.arrayofprices.push(originalPrice);
        this.arrayofqty.push(qty);
        this.arrayofOlditems.push(originalPrice);

        this.total += originalPrice * qty;
      }
    }
  }
  calculateBundlesAffiliate() {
    let bundleOriginalTotal = 0;
    let bundleEnteredTotal = 0;

    // لو مفيش bundles خلاص
    if (!this.selectedBundlesDetails || this.selectedBundlesDetails.length === 0) {
      return;
    }

    for (const b of this.selectedBundlesDetails) {

      const bundle = b.bundle;
      const qty = b.quantity ?? 1;

      // السعر الأصلي للباندل حسب نوع الحساب
      const originalPrice = bundle.pricea;

      // السعر اللي المستخدم دخله
      const enteredPrice = Number(b.price) || originalPrice;

      bundleOriginalTotal += originalPrice * qty;
      bundleEnteredTotal += enteredPrice * qty;
    }

    // ✅ حساب income + due للباندلز فقط
    const bundleDue =
      Math.round(bundleEnteredTotal) - Math.round(bundleOriginalTotal);

    // ✅ زوّد على الموجود
    this.due = Number(this.due || 0) + bundleDue;
    this.income = Number(this.income || 0) + bundleDue;
  }

  appendPostDtata() {
    if (this.tokenExists) {
      const addressStr = localStorage.getItem("shipping");

      if (addressStr) {
        const address = JSON.parse(addressStr);
        this.address = address.address;
        this.orderLocation = address.location_link == null ? null : address.location_link;
        this.cityId = address.city_id;
        this.grovId = address.government_id;
      } else {
        this.address = null;
      }
    }
    else {
      if (!this.addressFormComponent.addressForm.valid) {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "اكتب عنوان" : 'add Address',
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }

      const childFormData = this.addressFormComponent.addressForm.value;

      this.grovId = childFormData.government_id;
      this.cityId = childFormData.city_id;
      this.address = childFormData.address;
      this.orderLocation = childFormData.location_link;
    }
    this.dataForm = new FormData();
    if (this.paymentType == 3)
      this.dataForm.append('payment_type', String(this.paymentType));

    this.dataForm.append('is_from_client', 1);
    this.dataForm.append('grov_id', this.grovId);
    this.dataForm.append('city_id', this.cityId);
    this.dataForm.append('order_location', this.orderLocation);

    this.dataForm.append('client_name', this.client_name);

    this.dataForm.append('phone_number', this.phone_number);
    this.dataForm.append('another_phone', this.phone_number);
    // ✅ Send Bundles separately
    this.selectedBundlesDetails.forEach((bundle: any) => {
      const bundleItemsText = bundle.bundle.items
        .map((item: any) => `${item.stock.name_ar} x${item.quantity}`)
        .join(" , ");
      const fullBundleName =
        `${bundle.bundle.name_ar} : ${bundleItemsText}`;
      this.arrayofitems.push(fullBundleName);
      this.arrayofqty.push(bundle.quantity ?? 1);
      const price = bundle.pricea ?? bundle.bundle.pricea;
      this.arrayofprices.push(price);
      this.total += price * (bundle.quantity ?? 1);
    });
    this.dataForm.append('income', this.income);
    if (this.discount) {
      this.dataForm.append('discount', this.discount);
      this.dataForm.append('total', this.total + parseInt(this.delivery_fees) - this.discount);
    }
    else {
      this.dataForm.append('total', this.total + parseInt(this.delivery_fees));
    }
    this.dataForm.append('address', this.address);
    this.dataForm.append('note', this.note);

    this.dataForm.append('delivery_fees', this.delivery_fees);
    this.arrayofitems.forEach((item: any) => {
      this.dataForm.append('item[]', item);
    });

    this.arrayofqty.forEach((qty: any) => {
      this.dataForm.append('quantity[]', String(qty));
    });

    this.arrayofprices.forEach((price: any) => {
      this.dataForm.append('price[]', String(price));
    });

    this.arrayofOlditems.forEach((oldPrice: any) => {
      this.dataForm.append('itemsprices[]', String(oldPrice));
    });

    this.arrayofids.forEach((id: any) => {
      this.dataForm.append('product_id[]', String(id));
    });
    this.dataForm.append('order_status', "1");
    this.dataForm.append('user_id', this.userId);
    this.dataForm.append('due', 0);
    this.dataForm.append('duenow', 0);
    this.dataForm.append('warehouse_id', 1);
    this.selectedBundlesDetails.forEach((bundle: any, index: number) => {
      this.dataForm.append(
        `bundle_id[${index}]`,
        String(bundle.bundle.id)
      );
      this.dataForm.append(
        `bundle_qty[${index}]`,
        String(bundle.quantity ?? 1)
      );
      this.dataForm.append(
        `bundle_price[${index}]`,
        String(bundle.price ?? bundle.bundle.price)
      );
    });
  }
  onlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;

    // يسمح بالأرقام فقط
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  onSubmit() {
    this.contentReady = true;
    this.submitSelectedProducts();
    this.appendPostDtata();
    if (this.address == null) {
      Swal.fire({ icon: 'error', title: this.isAr ? "اكتب عنوان" : 'add your address', timer: 1500, showConfirmButton: false });
      this.contentReady = false;
      return;
    }
    this._orderService.addOrder(this.dataForm).subscribe({
      next: (res) => {
        const orderId = res?.order?.id;
        this.winProdcut(this.userId, orderId)
        if (!orderId) {
          this.contentReady = false;
          Swal.fire({ icon: 'error', title: 'Order created but no id returned' });
          return;
        }
        this.contentReady = false;
        if (this.paymentType === 0) {
          Swal.fire({ icon: 'success', title: this.isAr ? "اوردرك قيد الانتظار" : 'Order Placed', timer: 1500, showConfirmButton: false });
          this._cart.clearCart();
          this.router.navigateByUrl('/ordercompleted');
          return;
        }
        if (this.paymentType === 3) {
          Swal.fire({ icon: 'info', title: this.isAr ? "جاري فتح صفحة الدفع" : 'Opening payment', timer: 1200, showConfirmButton: false });
          localStorage.removeItem('free_delivery_reward');
          this._orderService.payOrder(orderId).subscribe({
            next: (payRes) => {
              const url = payRes?.sessionUrl || payRes?.data?.sessionUrl;
              if (!url) {
                Swal.fire({ icon: 'error', title: 'No sessionUrl returned' });
                return;
              }
              window.location.href = url;
            },
            error: (err) => {
              Swal.fire({ icon: 'error', title: 'Failed to start payment' });
            }
          });
        }
      },
      error: () => {
        Swal.fire({ icon: 'error', title: this.isAr ? "فشل حفط الاوردر" : 'Order Failed', confirmButtonText: this.isAr ? 'تمام' : 'ok' });
        this.contentReady = false;
      },
    });
  }
  createUserAddPlaceOrder() {
    this.contentReady = true;
    this.submitSelectedProducts();
    this.appendPostDtata();

    if (this.address == null) {
      Swal.fire({

        icon: 'error',
        title: this.isAr ? "اكتب عنوان" : 'add your address',
        showConfirmButton: false,
        timer: 1500,
      });
      this.contentReady = false;
      return
    }
    else if (this.client_name == null) {
      Swal.fire({

        icon: 'error',
        title: this.isAr ? "اكتب اسمك" : 'add your name',
        showConfirmButton: false,
        timer: 1500,
      });
      this.contentReady = false;
      return
    }
    else if (this.phone_number == null) {
      Swal.fire({

        icon: 'error',
        title: this.isAr ? "اكتب رقم تليفونك" : 'add your phone',
        showConfirmButton: false,
        timer: 1500,
      });
      this.contentReady = false;
      return
    }

    this.dataForm.append('first_name', this.client_name);
    this.dataForm.append('last_name', this.client_name);
    this.dataForm.append('username', this.phone_number);
    this.dataForm.append('password', this.phone_number);
    this.dataForm.append('password_confirmation', this.phone_number);

    this.dataForm.append('phone', this.phone_number);
    this.dataForm.append('type', "9");
    this._ResigteringService.user_Resigter(this.dataForm).subscribe({
      next: (res) => {
        this.gustUserId = res.user.id;
        this.dataForm.append('user_id', res.user.id);
        this._LoginService.setToken(res.token);
        this.createAddress()
      },
      error: (err) => {
        const usernameTaken =
          err?.status === 422 &&
          (
            err?.error?.message === 'The username has already been taken.' ||
            err?.error?.errors?.username?.includes('The username has already been taken.')
          );

        if (usernameTaken) {
          Swal.fire({
            icon: 'info',
            title: this.isAr ? 'رقم التليفون مسجل بالفعل' : 'Phone number already registered',
            text: this.isAr
              ? 'سيتم تسجيل الدخول واستكمال الطلب'
              : 'Logging you in and completing the order',
            timer: 1800,
            showConfirmButton: false,
          });

          this.loginAndContinueOrder();
          return;
        }

        this.contentReady = false;
        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'حصلت مشكلة في إنشاء المستخدم' : 'Error while creating user',
          text: this.isAr ? 'كلم الدعم' : 'Please contact support',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });
      },
    });
  }
  loginAndContinueOrder() {
    const body = {
      username: this.phone_number,
      password: this.phone_number
    };

    this._LoginService.user_login(body).subscribe({
      next: (res: any) => {
        this._LoginService.setToken(res.token);

        localStorage.setItem('username', res.user.username);

        this._userService.getUserId().subscribe({
          next: (data: any) => {
            this.userId = data['user_id'];
            this.gustUserId = this.userId;

            // اعمل append لزازوزر الجديد
            this.dataForm.append('user_id', this.userId);

            Swal.fire({
              icon: 'success',
              title: this.isAr ? 'تم تسجيل الدخول واستكمال الطلب' : 'Logged in successfully, continuing order',
              showConfirmButton: false,
              timer: 1500,
            });

            this.createAddress();
          },
          error: () => {
            this.contentReady = false;
            Swal.fire({
              icon: 'error',
              title: this.isAr ? 'تم تسجيل الدخول لكن تعذر جلب بيانات المستخدم' : 'Logged in but failed to load user data',
              confirmButtonText: this.isAr ? 'تمام' : 'OK',
            });
          }
        });
      },

      error: () => {
        this.contentReady = false;

        Swal.fire({
          icon: 'error',
          title: this.isAr
            ? 'رقم التليفون مسجل بالفعل لكن فشل تسجيل الدخول'
            : 'Phone exists but login failed',
          text: this.isAr
            ? 'جرّب تسجل دخول يدويًا'
            : 'Please login manually',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        }).then(() => {
          this.router.navigateByUrl('/Login');
        });
      },
    });
  }
  createAddress() {
    this.dataForm.append('address_title', 'المنزل');
    this.dataForm.append('address', this.address);
    this.dataForm.append('city_id', this.cityId);
    this.dataForm.append('government_id', this.grovId);
    this.dataForm.append('location_link', this.orderLocation);


    this.addressesService.createAddress(this.dataForm).subscribe({
      next: (res) => {
        this._orderService.addOrder(this.dataForm).subscribe({
          next: (res) => {
            Swal.fire({
              icon: 'success',
              title: this.isAr ? "اوردرك قيد الانتظار" : 'Order Placed',
              showConfirmButton: false,
              timer: 1500,
            });
            this._cart.clearCart();
            this.winProdcut(this.gustUserId, res.order.id)
            this.router.navigateByUrl('/ordercompleted');
          },
          error: (err) => {
            Swal.fire({
              icon: 'error',
              title: this.isAr ? "فشل حفط الاوردر" : 'Order Failed',
              confirmButtonText: this.isAr ? 'تمام' : 'ok',
            });
            this.contentReady = false;

          },
        });


      }
    });
  }
  debitWallet(user: any, order_id: any, amount: any) {
    this.walletService.useWalletBalance(user, order_id, amount).subscribe({
      next: (res) => {

      }

    })
  }
  winProdcut(user_id: any, order_id: any) {

    this.spinService.consume(user_id, order_id)
      .subscribe({
        next: (res) => {
          console.log('Reward consumed successfully');
        },
        error: (err) => {
          console.log('No reward to consume');
        }
      });

  }

}
